import { connect } from 'react-redux';
import { fetchMostFiskedArticles } from '../../../../actions';
import ArticleList from './article-list';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    articles: _.get(state, 'home.articlesMostFisked.data.articles', []),
    meta: _.get(state, 'home.articlesMostFisked.data.meta', {}),
    loading: !!_.get(state, 'loading.FETCH_MOST_FISKED', null),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchArticles: (offset=0, url=null) => {
      dispatch(fetchMostFiskedArticles(offset, url))
    },
  };
};

const ArticleListMostFisked = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticleList);

export default ArticleListMostFisked;
